import styled from '@emotion/styled';

export const SideBarScrollWrapper = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-flow: column nowrap;
  padding-bottom: 64px;
`;

export const SideBar = styled.div`
  flex: 0 0 256px;
  background: #ffffff;
  overflow: auto;
  display: flex;
  flex-flow: column nowrap;
`;

export const SidebarSectionName = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #545454;
  margin: 10px 0 5px 0;
`;

export const SidebarSection = styled.div`
  padding: 0 10px 10px 10px;
  margin: 0 0 30px 0;
`;

interface SidebarSectionLinkProps {
  active: boolean;
}

export const SidebarSectionLink = styled.div<SidebarSectionLinkProps>`
  display: flex;
  margin: 0 -10px;
  padding: 10px;
  border-bottom: solid 1px #dcdcdc;
  cursor: pointer;
  transition: background 450ms cubic-bezier(0.23, 1, 0.32, 1);
  background: ${(props) => (props.active ? '#e4e4e4' : 'transparent')};
  &:hover {
    background: whitesmoke;
  }
`;

export const BackButton = styled.div<{ touching?: boolean; dark?: boolean }>`
  width: 50px;
  height: 32px;
  cursor: pointer;
  background-color: ${({ dark }) => (dark ? 'transparent' : 'var(--colorBlueGray200)')};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  transition: all 0.2s ease-out;
  transform: ${({ touching }) => (touching ? 'scale(0.96)' : '1')};

  &:hover {
    background: #f9f9f9;
  }
`;

export const BackButtonIcon = styled.i`
  font-size: 15px;
  font-weight: bold !important;
  color: #000;
`;

export const SidebarTopBase = styled.div<{ dark: boolean }>`
  display: flex;
  padding: 16px 8px;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.14);
  background-color: ${({ dark }) => (dark ? 'var(--colorBlueGray1300)' : 'var(--colorWhite)')};
`;

export const SidebarTitle = styled.h1<{ dark: boolean }>`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ dark }) => (dark ? 'var(--colorWhite)' : 'var(--colorBlueGray1200)')};
`;

export const SidebarSectionItem = styled.div`
  display: flex;
  margin: 0 -10px;
  padding: 10px;
  border-bottom: solid 1px #dcdcdc;
`;

export const SidebarSectionItemIcon = styled.img`
  color: #ffffff;
  font-size: 18px;
  margin: 0 8px 0 0;
`;

export const SidebarSectionItemName = styled.div``;
